import * as React from "react";
import Hotkeys from "react-hot-keys";

// // // //

/**
 * Wire up a hotkey to a callback
 */
export function Hotkey(props: {
    keyName: string;
    allowRepeat?: boolean;
    onKeyDown: () => void;
}) {
    return (
        <Hotkeys
            keyName={props.keyName}
            allowRepeat={props.allowRepeat || false}
            onKeyDown={(_keyName: string, e: KeyboardEvent) => {
                e.stopPropagation();
                e.preventDefault();
                props.onKeyDown();
            }}
        />
    );
}
